import fontUrl from '../assets/fonts/inter-variable-optimized.woff2?url';

/** One font declaration per document, also available inside Shadow DOMs. */
export function registerFont(document) {
  if (document.getElementById('positive-nav-fonts')) return;
  const style = document.createElement('style');
  style.id = 'positive-nav-fonts';
  style.textContent = `@font-face {
    font-family: "Inter Variable Optimized";
    src: url("${fontUrl}") format("woff2");
    font-weight: 100 900;
    font-style: normal;
    font-display: block;
  }`;
  (document.head ?? document.documentElement).append(style);
}
